/* =========================================================================
   AttarHerb cart-fix (safety net)
   -------------------------------------------------------------------------
   The theme's AgreementCheckbox class binds `change` listeners to each
   `.js-agreement-checkbox` element once, at initial page load. When the
   minicart / cart re-renders via the Section Rendering API those elements
   are replaced and lose their listeners, so toggling the agreement checkbox
   no longer re-enables the checkout button — it stays `.disabled` with
   `pointer-events:none`, and the customer cannot check out.

   This script uses DOCUMENT-LEVEL event delegation, so it works no matter
   how many times the cart HTML is re-rendered. It also runs a periodic
   safety sweep: any checkout button gated by a CHECKED agreement checkbox
   is force-enabled.

   The agreement gate is currently DISABLED in theme settings
   (checkout_agreement = false); this file protects the store if it is
   ever switched back on.
   ========================================================================= */
(function () {
  'use strict';

  function applyState(checkbox) {
    if (!checkbox || !checkbox.dataset || !checkbox.dataset.button) return;
    var selector = checkbox.dataset.button; // e.g. ".shopify-payment-agree"
    var gated;
    try { gated = document.querySelectorAll(selector); } catch (e) { return; }
    var twins = document.querySelectorAll('.js-agreement-checkbox[data-button="' + selector + '"]');
    twins.forEach(function (el) { el.checked = checkbox.checked; });
    gated.forEach(function (el) {
      if (checkbox.checked) {
        el.classList.remove('disabled');
        el.classList.add('enabled');
      } else {
        el.classList.remove('enabled');
        el.classList.add('disabled');
      }
    });
  }

  function sweep() {
    document.querySelectorAll('.js-agreement-checkbox').forEach(function (checkbox) {
      if (checkbox.checked) applyState(checkbox);
    });
  }

  // Delegated change handler — survives any cart re-render.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('js-agreement-checkbox')) {
      applyState(t);
    }
  }, true);

  // Re-run after the theme replaces cart HTML (add to cart / qty change).
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { sweep(); break; }
    }
  });

  function boot() {
    sweep();
    var targets = document.querySelectorAll('cart-items, .minicart-drop, #MainContent, .page-content');
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    // Low-frequency fallback sweep — cheap and catches anything missed.
    setInterval(sweep, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
